module.exports = __webpack_public_path__ + "img/RS.d64b39ee.jpg";